import * as React from 'react';
import {StyleSheet, Text, View} from "react-native";

const CapexDetailComponent = ({capex}) => (
    <View style={styles.capexHeader}>
        <Text style={styles.capexTitle}>{capex.name} - {capex.code}.{capex.code_sub}</Text>
        <Text style={styles.capexDescription}>{capex.description.trim()}</Text>
        {capex.budget && <Text style={styles.capexInfo}>
            Presupuesto inicial: ${capex.budget}
        </Text>}
        {capex.current_budget && <Text style={styles.budget}>
            Presupuesto actual: ${capex.current_budget}
        </Text>}
        {capex.year && <Text style={styles.capexInfo}>
            Año: {capex.year}
        </Text>}
        {(capex.area?.name && capex.department?.name)&& <Text style={styles.capexInfo}>
            Área: {capex.area?.name} | Departamento: {capex.department?.name}
        </Text>}
        <Text style={styles.capexInfo}>
            {capex.is_auto ? 'AUTO' : 'CAPEX'}
        </Text>
    </View>
);

export default CapexDetailComponent


const styles = StyleSheet.create({
    capexHeader: {
        backgroundColor: '#ffffff',
        marginVertical: 8,
        padding: 14,
        borderRadius: 10,
        shadowColor: '#000',
        shadowOffset: {width: 0, height: 2},
        shadowOpacity: 0.05,
        shadowRadius: 4,
        elevation: 2,
        borderColor: '#bcbbbb',
        borderWidth: 1
    },
    capexTitle: {
        fontSize: 20,
        fontWeight: '700',
        marginBottom: 6,
        color: '#2c3e50',
    },
    capexDescription: {
        fontSize: 14,
        color: '#7f8c8d',
        marginBottom: 6,
    },
    capexInfo: {
        fontSize: 13,
        color: '#34495e',
        marginBottom: 2,
    },

});
